// extracted by mini-css-extract-plugin
export default {"table":"table_table__x4xno","table__row":"table_table__row__iYJAr","table__cell":"table_table__cell__Qq0+W","table__delete-button":"table_table__delete-button__IY1OC"};